/** biome-ignore-all lint/a11y/noSvgWithoutTitle: SVG is purely visual */
import { Typography } from "@mui/material";

const AdmLogo = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.5 10C5.77614 10 6 10.2239 6 10.5L6 14.5C6 14.7761 5.77614 15 5.5 15C5.22386 15 5 14.7761 5 14.5L5 10.5C5 10.2239 5.22386 10 5.5 10Z"
      fill="white"
    />
    <path
      d="M5.5 14.75C5.63807 14.75 5.75 14.6381 5.75 14.5L5.75 10.5C5.75 10.3619 5.63807 10.25 5.5 10.25C5.36193 10.25 5.25 10.3619 5.25 10.5L5.25 14.5C5.25 14.6381 5.36193 14.75 5.5 14.75ZM5.5 15.25C5.08579 15.25 4.75 14.9142 4.75 14.5L4.75 10.5C4.75 10.0858 5.08579 9.75 5.5 9.75C5.91421 9.75 6.25 10.0858 6.25 10.5L6.25 14.5C6.25 14.9142 5.91421 15.25 5.5 15.25Z"
      fill="white"
    />
    <path
      d="M3.5 1C3.77614 1 4 1.22386 4 1.5L4 6.5C4 6.77614 3.77614 7 3.5 7C3.22386 7 3 6.77614 3 6.5L3 1.5C3 1.22386 3.22386 1 3.5 1Z"
      fill="white"
    />
    <path
      d="M3.5 0.5C4.05228 0.5 4.5 0.947715 4.5 1.5L4.5 6.5C4.5 7.05228 4.05228 7.5 3.5 7.5C2.94772 7.5 2.5 7.05228 2.5 6.5L2.5 1.5C2.5 0.947715 2.94772 0.5 3.5 0.5Z"
      fill="white"
    />
    <path
      d="M9.5 10C9.77614 10 10 10.2239 10 10.5L10 14.5C10 14.7761 9.77614 15 9.5 15C9.22386 15 9 14.7761 9 14.5L9 10.5C9 10.2239 9.22386 10 9.5 10Z"
      fill="white"
    />
    <path
      d="M9.5 14.75C9.63807 14.75 9.75 14.6381 9.75 14.5L9.75 10.5C9.75 10.3619 9.63807 10.25 9.5 10.25C9.36193 10.25 9.25 10.3619 9.25 10.5L9.25 14.5C9.25 14.6381 9.36193 14.75 9.5 14.75ZM9.5 15.25C9.08579 15.25 8.75 14.9142 8.75 14.5L8.75 10.5C8.75 10.0858 9.08579 9.75 9.5 9.75C9.91421 9.75 10.25 10.0858 10.25 10.5L10.25 14.5C10.25 14.9142 9.91421 15.25 9.5 15.25Z"
      fill="white"
    />
    <path
      d="M11 4C11 2.71697 10.1655 2 9.5 2C8.83454 2 8 2.71697 8 4C8 5.28303 8.83454 6 9.5 6C10.1655 6 11 5.28303 11 4ZM13 4C13 6.03068 11.596 8 9.5 8C7.40403 8 6 6.03068 6 4C6 1.96932 7.40403 0 9.5 0C11.596 0 13 1.96932 13 4Z"
      fill="white"
    />
  </svg>
);

const DtgLogo = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1" y="2" width="9" height="1" rx="0.5" fill="white" />
    <rect x="4" y="4" width="9" height="1" rx="0.5" fill="white" />
    <rect x="1" y="13" width="9" height="1" rx="0.5" fill="white" />
    <rect x="4" y="11" width="9" height="1" rx="0.5" fill="white" />
    <rect x="6" y="7" width="9" height="2" rx="1" fill="white" />
  </svg>
);

const GbdLogo = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2.66895" y="11.1289" width="3.52552" height="3.53929" rx="1.76276" fill="white" />
    <rect x="8.97998" y="8.60156" width="3.52552" height="3.53929" rx="1.76276" fill="white" />
    <rect x="3.92578" y="3.54688" width="3.52552" height="3.53929" rx="1.76276" fill="white" />
    <rect x="8.70801" y="2" width="3.52552" height="3.53929" rx="1.76276" fill="white" />
  </svg>
);

const VdaLogo = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="5" cy="5" r="3" fill="white" />
    <circle cx="11" cy="11" r="3" fill="white" />
  </svg>
);

export function Logo(props: { variant: string }): JSX.Element {
  return (
    <div
      style={{
        backgroundColor: "var(--color-brand-primary-500)",
        padding: "8px",
        borderRadius: "10px",
        height: "32px",
        minWidth: "63px",
        display: "flex",
        gap: "4px",
        alignItems: "center",
        marginLeft: "16px",
        marginRight: "16px",
      }}
    >
      {props.variant === "gbd" && <GbdLogo />}
      {props.variant === "adm" && <AdmLogo />}
      {(props.variant === "dtg" || props.variant === "dtg-home") && <DtgLogo />}
      {props.variant === "vda" && <VdaLogo />}
      <Typography variant="caption" sx={{ color: "var(--color-neutral-100)" }}>
        {props.variant === "gbd" && "GBD"}
        {props.variant === "adm" && "ADM"}
        {(props.variant === "dtg" || props.variant === "dtg-home") && "DTG"}
        {props.variant === "vda" && "VDA"}
      </Typography>
    </div>
  );
}
